function formatMoney(cents) {
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cents / 100)
}

$(document).ready(function () {
    let goalContainer = document.querySelector('.goal-container');
    let goalFreeShippingThresholdEl = document.querySelector('.free-shipping-threshold');
    let goalFreeGiftThresholdEl = document.querySelector('.free-gift-threshold');
    let goalReachedEl = document.querySelector('.goal-reached');

    let freeShippingText = document.querySelector('.free-shipping-text');
    let freeShippingTextZero = document.querySelector('.free-shipping-text-zero');
    let freeGiftText = document.querySelector('.free-gift-text');
    let successText = document.querySelector('.success-text');

    let remainingPriceShippingEls = document.querySelectorAll('.remaining-price-shipping');
    let remainingPriceGiftEls = document.querySelectorAll('.remaining-price-gift');

    let freeShippingGoal = parseInt(goalContainer.dataset.freeShippingGoal);
    let freeGiftGoal = parseInt(goalContainer.dataset.freeGiftGoal);

    let updateEls = function(cart) {
        freeShippingTextZero.classList.add('d-none');
        freeShippingText.classList.add('d-none');
        freeGiftText.classList.add('d-none');
        successText.classList.add('d-none');

        let cartTotal = cart.total_price;
        if (cartTotal === 0) {
            freeShippingTextZero.classList.remove('d-none');
        } else if(cartTotal > 0 && cartTotal <= freeShippingGoal) {
            freeShippingText.classList.remove('d-none');
        } else if (cartTotal > freeShippingGoal && cartTotal < freeGiftGoal) {
            freeGiftText.classList.remove('d-none');
        } else {
            successText.classList.remove('d-none');
        }

        if (cartTotal >= freeShippingGoal) {
            goalFreeShippingThresholdEl.classList.add('reached');
        } else {
            goalFreeShippingThresholdEl.classList.remove('reached');
        }

        if (cartTotal >= freeGiftGoal) {
            goalFreeGiftThresholdEl.classList.add('reached');
        } else {
            goalFreeGiftThresholdEl.classList.remove('reached');
        }

        goalFreeShippingThresholdEl.style.width = (Math.min(freeShippingGoal / freeGiftGoal, 1) * 100) + '%';
        goalReachedEl.style.width = (Math.min(cartTotal / freeGiftGoal, 1) * 100) + '%';

        remainingPriceShippingEls.forEach(el => {
            el.innerHTML = formatMoney(Math.max(0, freeShippingGoal - cartTotal));
        });

        remainingPriceGiftEls.forEach(el => {
            el.innerHTML = formatMoney(Math.max(0, freeGiftGoal - cartTotal));
        });
    }

    $(document).on('cart.requestComplete', (event, cart) => {
        updateEls(cart);
    });

    updateEls(SHYNE.cart);
});
